import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Renderer2,
} from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { ToastrService } from "ngx-toastr";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { EmployeeService } from "../../shared/service/employee.service";
import { isUndefined, isNullOrUndefined, isNull } from "util";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import * as _moment from "moment";
import { DatePipe, formatDate } from "@angular/common";
import { HrEmpAdddressDetails } from "../../shared/models/HrEmpAddressDetails";
import { HREmployeeDetails } from "../../shared/models/hremployeecommunicationdetails.model";
import { File_Types } from "../../shared/UploadFileTypes";
import { UserService } from "../../shared/service/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import { DepartmentsService } from "../../shared/service/departments.service";
import { ExitReason } from "../../../Models/ExitReason";
import { Offboarding } from "../../shared/models/Offboarding";
import { ExitReasonDetails } from "../../shared/models/ExitReasonDetails";
import { AppConfig } from "../../app.config";
import { MatAutocompleteSelectedEvent, MatDialog } from "@angular/material";
import { dataService } from "../../shared/service/dataservice.service";
import { OnboardingExportToEmp } from "../../shared/models/onboardingExportToEmp";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { HrEmployeeDetailsComponent } from "../../hr/hr-employee-details/hr-employee-details.component";

const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
type TeamListCallback = (teamList: any[]) => void;
type EmpTypeListCallback = (eeTypeList: any[]) => void;

@Component({
  selector: "app-hr-emp-initiate-exit",
  templateUrl: "./hr-emp-initiate-exit.component.html",
  styleUrls: ["./hr-emp-initiate-exit.component.scss"],

  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class HrEmpInitiateExitComponent {
  @Input() empCode: number;
  @Output("employeeOff") employeeOff = new EventEmitter();
  offboardingForm: FormGroup;
  todayDate: Date;
  reasonlist: any[];
  offboardinglist: ExitReasonDetails[];
  offboarding: Offboarding;
  teamList: any;
  filteredTeamList: any;
  eeTypeList: any;
  pmList: any;
  poList: any;
  destroyed = false;
  datePipe: DatePipe;
  reasonDetail: string;
  exitreasonid: number;
  empName: any;
  LoginEmpCode: any;
  MAX_SIZE: number = 1048576;
  selectedPM: any;
  selectedPO: any;
  error: any;
  empList: any[] = [];
  filteredEmpList: any[] = [];
  selectedEmployees: any[] = [];
  searchTerm: string;
  searchControl = new FormControl();
  employees: any;
  loader: boolean;
  EmployeeCode: any;
  employeeList: any;
  HREmp: BasicEmployeeDetails;
  DOJ: any;
  TeamId: any;
  EeTypeId: any;
  selectedMasterIds: any;
  displayCC: string[];
  ccEntries: any[] = [];
  finalShowCC: string[];
  result: any;
  fieldsDisabled: boolean = false;
  status: any;
  selected: any = null;
  hideOffboardingEmpList: any[] = [];
  onlyIndianEmployees: any[] = [];
  filteredList: any[] = [];
  @ViewChild("exitFile", { static: false }) exitFile: ElementRef;
  MaxItemsList: any;
  ConfirmedLWD: Date;
  ExitoffboardingID: any;
    ProjectMgr: any;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    public router: Router,
    private hrSvc: OnboardingService,
    public toastr: ToastrService,
    public file_Svc: FileUploadService,
    private deptSvc: DepartmentsService,
    private emp_Svc: EmployeeService,
    public dialog: MatDialog,
    private SVC: dataService,
    private cdr: ChangeDetectorRef,
    private config: AppConfig,
    private formBuilder: FormBuilder,
    private HrEmployeeDetailsComponent: HrEmployeeDetailsComponent,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    this.todayDate = new Date();
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];
    });
    this.offboarding = new Offboarding();

    this.LoginEmpCode = this.userService.getEmpCode();
    if (!isNullOrUndefined(this.LoginEmpCode)) {
      this.offboardingForm = this.formBuilder.group({
        ResignationDate: [moment(), []],
        IndicativeLWD: [moment(), []],
        To: ["", []],
        CC: ["", []],
        ReasonID: ["", [Validators.required]],
        Comments: ["", []],
        ExitEmailFile: ["", []],
        ProjectManagers: ["", []],
      });
      this.getActivePeopleManager();
      this.getActiveProjectManagers();
     // this.getOffboardingdetailsbyCode()
      this.getExitReasonById();
      this.getEmployeeList();
      this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe((data) => {
        this.DOJ = data && data.DOJ;
        this.TeamId = data && data.TeamId;
        this.EeTypeId = data && data.EeTypeId;
        this.GetProbation(this.DOJ, this.TeamId, this.EeTypeId);
      });
    }
  }

  getExitReasonById() {
    this.emp_Svc.GetExitReasonByID(1).subscribe((data: any) => {
      this.reasonlist = data;
    });
  }

  onChangeCCValues(val) {
    if (!this.selectedMasterIds) {
      this.selectedMasterIds = [];
    }
    if (Array.isArray(val)) {
      val.forEach(item => {
        this.selectedMasterIds.push(item);
      });
    } else {
      this.selectedMasterIds.push(val);
    }
    this.updateFilteredEmpList();
  }

  updateFilteredEmpList() {
    this.filteredEmpList = this.empList.filter(emp =>
      !this.selectedMasterIds.includes(emp.EmpCode)
    );
  }

  fetchURl(url) {
    this.emp_Svc
      .getDownloadURL(url)
      .subscribe((data: any) => {
        window.open(data, '_blank');
      });
  }


  getActivePeopleManager() {
    this.emp_Svc
      .getActivePeopleManagerByCode(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.pmList = data;
        this.selectedPM = this.pmList;
      });
  }

  getActiveProjectManagers() {
    this.emp_Svc.getActiveProjectManagersByCode(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.poList = data;
        if (this.poList) {
          this.selectedPO = this.poList;
          this.selected = this.poList != null && this.poList.split(",").length > 1 ? this.poList.split(",").join(", ") : this.selectedPO;
        }
        this.getOffboardingdetailsbyCode();
      });
  }

  getFormattedPO(): string {
    if (this.offboarding && (this.offboarding.finalStatus === "Submitted" || this.offboarding.finalStatus === "Approved" || this.offboarding.finalStatus === "Confirmed" || this.offboarding.finalStatus === "Rejected" || this.offboarding.finalStatus === "Revoked")) {
      return this.ProjectMgr ? this.ProjectMgr.split(' ').join(' ') : '';
    }
    else {
      return this.selected ? this.selected.split(' ').join(' ') : '';
    }

  }
  getEmployeeList() {
    this.emp_Svc.getActiveEmployeeBasicDetails().subscribe(
      (data: any[]) => {
        const tempList = [];
        const pmCode = this.offboarding.To != null ? this.offboarding.To.split(' - ')[1] : this.selectedPM.split(' - ')[1];
        const poCodes = this.offboarding.ProjectManagers && this.offboarding.ProjectManagers ? this.offboarding.ProjectManagers && this.offboarding.ProjectManagers.split(',').map(code => code && code.split(' - ')[1]).filter(Boolean) : this.selected && this.selected.split(',').map(code => code && code.split(' - ')[1]) || [];
        const excludedCodes = [pmCode, ...poCodes, String(this.LoginEmpCode)].filter(code => code);

        this.empList = data;

        this.empList.forEach((el) => {
          if (!excludedCodes.includes(String(el.EmpCode))) {
            let item = el;
            item.recDisplayName = el.NamePerRecords + " - " + el.EmpCode;
            item.recEmpCode = el.EmpCode;
            tempList.push(item);
          }
        });

        this.empList = tempList;
        this.filteredEmpList = this.empList;
      },
      (error) => (this.error = error)
    );
  }


  filterEmployees(query: string): void {
    this.filteredEmpList = this.employees.filter((emp) =>
      emp.recDisplayName.toLowerCase().includes(query.toLowerCase())
    );
  }

  getTeamList(callback: TeamListCallback) {
    this.deptSvc.getMasterGroupByCategory("Team").subscribe((data: any) => {
      this.deptSvc
        .getMasterGroupByGroupID(data[0].ID)
        .subscribe((dataList: any[]) => {
          this.teamList = dataList;
          this.teamList = this.teamList.filter(
            (team) => team.Value != "Onshore"
          );
          callback(this.teamList);
        });
    });
  }

  getEeTypeList(callback: EmpTypeListCallback) {
    this.deptSvc.getMasterGroupByCategory("EeType").subscribe((data: any) => {
      this.deptSvc
        .getMasterGroupByGroupID(data[0].ID)
        .subscribe((dataList: any) => {
          this.eeTypeList = dataList;
          callback(this.eeTypeList);
        });
    });
  }

  GetProbation(DOJ: string, TeamId: number, EeTypeId: number) {
    //console.log("GetProbation called with DOJ:", DOJ, "TeamId:", TeamId, "EeTypeId:", EeTypeId);
    const doj = new Date(DOJ);
    let probation = false;

    if (DOJ) {
      this.getTeamList((teamList) => {
        const teamVal = teamList.find((team) => team.ID === TeamId);
        this.getEeTypeList((eeTypeList) => {
          const eeTypeVal = eeTypeList.find((emp) => emp.ID === EeTypeId);
          const TeamValue = teamVal ? teamVal.Value : null;
          const EeTypeValue = eeTypeVal ? eeTypeVal.Value : null;

          if (TeamValue === "Offshore" && EeTypeValue === "Regular") {
            doj.setMonth(doj.getMonth() + 6);
          } else if (
            (TeamValue === "Onshore" || TeamValue === "Onsite") &&
            EeTypeValue === "Regular"
          ) {
            doj.setDate(doj.getDate() + 89);
          } else if (TeamValue === "Offshore" && EeTypeValue === "Trainee") {
            doj.setFullYear(doj.getFullYear() + 1);
          }

          probation = doj >= new Date();

          const indicativeLWD = new Date();
          indicativeLWD.setDate(
            indicativeLWD.getDate() + (probation ? 29 : 59)
          );
          this.offboarding.IndicativeLWD = indicativeLWD;

          if (!this.destroyed) {
            this.cdr.detectChanges();
          }
        });
      });
    }
  }



  handleFile(event) {
    if (event.target.files == undefined) {
      this.offboarding.ExitEmailFile = null;
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      //  Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        this.offboarding.ExitEmailFile = this.file_Svc.readAndUploadFile(files);
        this.offboarding.ExitEmailFilePath = null;
      } else {
        this.toastr.warning(
          " File: " +
            files[0].name +
            " exceeds 1MB hence it cannot be uploaded."
        );
        //  Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
        //this.FinanceForm.controls.CancelledChequeFile.reset();
      }
    }
  }
  validFileType(file) {
    let types = File_Types;
    return types.includes(file.type);
  }


  handleExitFile(event) {
    if (event.target.files == undefined) {
      this.offboarding.ExitEmailFile = null;
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        event.srcElement.value = null;
        event.currentTarget.value = null;
        return; 
      }
      if (files[0].size < this.MAX_SIZE) {
        const fileToUpload = this.file_Svc.readAndUploadFile(files);
        this.offboarding.ExitEmailFile = fileToUpload;

        const reader = new FileReader();
        reader.onload = () => {
          this.offboarding.ExitEmailFile.fileAsBase64 = reader.result.toString();
          this.uploadExitFile(); 
        };
        reader.readAsDataURL(files[0]); 
      } else {
        this.toastr.warning(
          " File: " +
          files[0].name +
          " exceeds 1MB hence it cannot be uploaded."
        );
        // Clear the input
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
    }
  }
  uploadExitFile() {
    this.loader = true;
    this.getOffboardingdetailsbyCode();
    this.offboarding.ID = this.ExitoffboardingID;
    this.emp_Svc.UploadExitFile(this.offboarding).subscribe(
      (data: Offboarding) => {
        const message = "Document Uploaded Successfully";
        this.toastr.success(message);
        this.loader = false;
        this.getOffboardingdetailsbyCode();
        this.offboardingForm.get('ExitEmailFile').reset();
      })
  }

  deleteExitFile() {
    this.loader = true;
    this.getOffboardingdetailsbyCode();
    this.offboarding.ID = this.ExitoffboardingID;
    this.emp_Svc.DeleteExitFile(this.offboarding).subscribe(
      (data: Offboarding) => {
        const message = "Document Deleted Successfully";
        this.toastr.success(message);
        this.loader = false;
        this.getOffboardingdetailsbyCode();
      })
  }

  SaveOffboardingDetails(status: string) {
    window.scrollTo(0, 0);
    this.loader = true;

    this.datePipe = new DatePipe("en-US");
    if (!isNullOrUndefined(this.offboarding.ResignationDate)) {
      this.offboarding.ResignationDate = new Date(
        this.datePipe.transform(
          this.offboarding.ResignationDate,
          this.config.dateFormat()
        )
      );
    }
    if (!isNullOrUndefined(this.offboarding.IndicativeLWD)) {
      this.offboarding.IndicativeLWD = new Date(
        this.datePipe.transform(
          this.offboarding.IndicativeLWD,
          this.config.dateFormat()
        )
      );
    }

    var now = new Date();
    var mm = now.getMonth() + 1;
    var currentYear;
    var year;
    currentYear = now.getFullYear();
    year = now.getFullYear().toString().substr(2, 2);
    if (3 < mm) {
      currentYear = now.getFullYear();
      year = now.getFullYear().toString().substr(2, 2);
    } else {
      currentYear = now.getFullYear() - 1;
      year = (now.getFullYear() - 1).toString().substr(2, 2);
    }
    this.offboarding.FinancialYear = currentYear + "-" + (parseInt(year) + 1);

    if (!this.offboarding.ReasonID) {
      this.loader = false;
      this.toastr.warning("Select Reason");
      return;
    }

    this.offboarding.CreatedBy = this.LoginEmpCode;
    this.offboarding.ModifiedBy = this.LoginEmpCode;
    this.offboarding.finalStatus = status;
    this.offboarding.FromEmp = true;
    this.offboarding.Designation = "Employee";
    this.offboarding.ExitID = 1;
    this.offboarding.EmpCode = this.LoginEmpCode;
    this.offboarding.ResignationDate = this.todayDate;
    this.offboarding.To = this.selectedPM;
    this.offboarding.ProjectManagers = this.selected ? this.selected : null;
    //this.offboarding.CC = this.selectedMasterIds ? this.selectedMasterIds : null;

    if (this.selectedMasterIds) {
      const ccEntries = this.selectedMasterIds
        .map((empCode) => {
          const employee = this.empList.find((emp) => emp.EmpCode === empCode);
          return employee ? employee.recDisplayName : null;
        })
        .filter((entry) => entry !== null);

      this.offboarding.CC = ccEntries.join(",");
    } else {
      this.offboarding.CC = null;
    }

    this.offboardingForm.controls.ExitEmailFile.reset();

    if (status === "Submitted") {
      const msg = "Are you sure to submit the resignation?";
      const dialogData = new ConfirmDialogModel(
        " ",
        msg,
        "Submit"
      );
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "800px",
        data: dialogData,
      });

      dialogRef.afterClosed().subscribe(
        (dialogResult) => {
          this.loader = false;

          if (dialogResult) {
            this.emp_Svc.SaveOffboardingDetails(this.offboarding).subscribe(
              (data: Offboarding) => {
                if (data.ErrorMsg === "Already existed") {
                  this.toastr.error("User already submitted resignation");
                  this.loader = false;
                } else {
                  const message = "Resignation Submitted Successfully";
                  this.toastr.success(message);
                  this.loader = false;
                  this.disableFormFields();
                  this.getEmployeeList();
                  this.getOffboardingdetailsbyCode();
                }
              },
              (error) => (this.error = error)
            );
          } else {
            this.loader = false;
            //this.fieldsDisabled = false;
            this.enableFormFields();
            this.offboarding.finalStatus = "Saved";
          }
        },
        (error) => {
          this.loader = false;
          this.result = error;
        }
      );
    } else if (status === "Saved") {
      this.emp_Svc.SaveOffboardingDetails(this.offboarding).subscribe(
        (data: Offboarding) => {
          if (data.ErrorMsg === "Already existed") {
            this.toastr.error("User already submitted resignation");
            this.loader = false;
          } else {
            const message = "Resignation Saved Successfully";
            this.toastr.success(message);
            this.loader = false;
            this.enableFormFields();
            this.getEmployeeList();
            this.getOffboardingdetailsbyCode();
          }
        },
        (error) => (this.error = error)
      );
    }
  }

  getFileName() {
    if (this.offboarding.ExitEmailFileName != null)
      return this.offboarding.EmpCode+"_Intimation"
    else
      return null;
  }

  //disableFormFields() {
  //  this.offboardingForm.disable();
  //}

  disableFormFields() {
    Object.keys(this.offboardingForm.controls).forEach(controlName => {
      if (controlName !== 'ExitEmailFile') {
        this.offboardingForm.controls[controlName].disable();
      }
    });
  }


  enableFormFields() {
    this.offboardingForm.enable();
  }

  getOffboardingdetailsbyCode() {
    return new Promise((resolve, reject) => {
      this.emp_Svc
        .getOffboardingDetails(this.LoginEmpCode)
        .subscribe((data: any) => {
          if (data) {
            this.ConfirmedLWD = data.LastWorkingDay ? data.LastWorkingDay : null;
            this.ExitoffboardingID = data.ID;
          }
          if (data && data.isRevoked) {
            this.offboarding = new Offboarding();
          } else {
            this.offboarding = data || new Offboarding();
          }
          this.HrEmployeeDetailsComponent.OffboardingDetails = this.offboarding;
          this.HrEmployeeDetailsComponent.checkBoxState();

          if (
            this.offboarding.finalStatus === "Submitted" ||
            this.offboarding.finalStatus === "Approved" ||
            this.offboarding.finalStatus === "Rejected" || this.offboarding.finalStatus == 'Confirmed'
          ) {
            this.disableFormFields();
          }

          if (this.offboarding.CC) {
            const ccEntries = this.offboarding.CC.split(",").map(entry => {
              const [recDisplayName, empCode] = entry.split(" - ");
              return { recDisplayName, empCode: Number(empCode) };
            });
            this.selectedMasterIds = ccEntries.map(entry => entry.empCode);
          }

          if (this.offboarding && (this.offboarding.finalStatus === "Submitted" || this.offboarding.finalStatus === "Approved" || this.offboarding.finalStatus === "Confirmed" || this.offboarding.finalStatus === "Rejected" || this.offboarding.finalStatus === "Revoked")) {
            this.MaxItemsList = 10;
          }
          else {
            this.MaxItemsList = 3;
          }
          resolve();

          //this.getEmployeeList();
    })
    
        //this.getMaxSelectedItems();

        //if (this.offboarding.CC) {
        //  const ccEntries = this.offboarding.CC.split(",");
        //  this.selectedMasterIds = ccEntries.map((entry) => {
        //    const [recDisplayName, EmpCode] = entry.split(" - ");
        //    return EmpCode;
        //  });
        //}
      });
  }

 

  ResetData() {
    this.offboardingForm.patchValue({
      ReasonID: "",
      Comments: "",
      CC: "",
      ExitEmailFile: [null],
    });
    if (this.exitFile) {
      this.exitFile.nativeElement.Clear();
    }
  }

  Cancel() {
    this.getOffboardingdetailsbyCode();
    const currentIndicativeLWD =
      this.offboardingForm.get("IndicativeLWD").value;
    this.offboardingForm.patchValue({
      ExitEmailFile: [null],
      IndicativeLWD: currentIndicativeLWD,
    });
  }
}
